/* ==========================================================================
   Vael 3.0 — "Campo", base de Vael 4.0 — Regalos.
   4.0: sin apertura (el encabezado ya no la imprime); menú, colección y producto
   con personalización (foto / nombre) enviada como formulario multipart.
   GSAP + ScrollTrigger + Lenis cuando están disponibles; todo degrada
   sin ellos. Respeta prefers-reduced-motion y usa una versión ligera en móvil.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document, win = window, html = doc.documentElement;
  var reduce = !!(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var mobile = !!(win.matchMedia && win.matchMedia('(max-width: 749px)').matches);
  var hasGsap = typeof win.gsap !== 'undefined';
  var hasST = hasGsap && typeof win.ScrollTrigger !== 'undefined';
  var lenis = null;
  var strings = win.v3Strings || {};
  win.__vaelReady = true;

  function $(sel, root) { return (root || doc).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function money(cents) {
    var n = Math.round(cents / 100);
    return '$' + n.toLocaleString('es-MX') + ' MXN';
  }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  /* ---------- Scroll suave ---------- */
  function initLenis() {
    if (reduce || mobile || typeof win.Lenis === 'undefined') return;
    lenis = new win.Lenis({ lerp: 0.1, wheelMultiplier: 1, smoothWheel: true });
    if (hasST) {
      lenis.on('scroll', win.ScrollTrigger.update);
      win.gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      win.gsap.ticker.lagSmoothing(0);
    } else {
      (function raf(t) { lenis.raf(t); win.requestAnimationFrame(raf); })(0);
    }
    win.v3Lenis = lenis;
  }
  if (hasST) win.gsap.registerPlugin(win.ScrollTrigger);

  /* ---------- Carrito (usa el cajón de Dawn) ---------- */
  function cartAdd(items, cb) {
    var body = { items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: win.location.pathname };
    return fetch((win.routes && win.routes.cart_add_url) || '/cart/add', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.status >= 400) throw new Error(res.description || res.message || 'cart');
      var drawer = $('cart-drawer');
      if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        if (drawer && drawer.renderContents && res.sections) {
        try { drawer.renderContents(res); } catch (e) { /* no-op */ }
      }
      syncCount();
      if (cb) cb(res);
      return res;
    });
  }
  function syncCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-v3-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    }).catch(function () {});
  }
  function watchBubble() {
    var b = $('#cart-icon-bubble');
    if (!b || !('MutationObserver' in win)) return;
    new MutationObserver(function () {
      var s = b.querySelector('.cart-count-bubble span[aria-hidden]');
      var n = s ? parseInt(s.textContent, 10) || 0 : 0;
      $$('[data-v3-cart-count]').forEach(function (el) { el.textContent = n; });
    }).observe(b, { childList: true, subtree: true });
  }
  function openDrawer(e) {
    var drawer = $('cart-drawer');
    if (!drawer || !drawer.open) return;
    e.preventDefault();
    drawer.open(e.currentTarget);
  }

  /* ---------- Apertura ---------- */
  function opening() {
    var el = $('.v-open');
    if (!el) return;
    var done = false;
    try { if (win.localStorage.getItem('vael_opened')) { el.remove(); html.classList.remove('v3-opening'); return; } } catch (e) {}
    if (reduce) {
      el.style.transition = 'opacity .6s ease';
      setTimeout(function () { el.style.opacity = '0'; setTimeout(finish, 600); }, 700);
      return;
    }
    var logo = $('.v-open__logo', el), bar = $('.v-open__bar i', el), cnt = $('.v-open__cnt', el), skip = $('.v-open__skip', el);
    var vit = $('.v-vit__stage') || $('.v-vit-m') || $('#MainContent');
    var start = Date.now(), loaded = doc.readyState === 'complete', value = 0, raf, doneAt = 0;
    on(win, 'load', function () { loaded = true; });
    if (hasGsap) {
      win.gsap.to(logo, { opacity: 1, scale: 1, duration: 1.2, ease: 'expo.out', delay: 0.1 });
    } else { logo.style.opacity = '1'; logo.style.transform = 'none'; }
    if (vit) { vit.style.opacity = '0'; vit.style.transform = 'scale(1.18)'; vit.style.transformOrigin = '50% 50%'; }

    function tick() {
      // Independiente de los cuadros por segundo: 0→88 en 1.6 s (ease-out), y 88→100 en 0.35 s cuando la página ya cargó (mínimo 1.5 s).
      var t = Date.now() - start;
      var e = Math.min(1, t / 1600); e = 1 - Math.pow(1 - e, 3);
      var ready = (loaded || t > 3600) && t > 1500;
      if (ready && !doneAt) doneAt = Date.now();
      value = ready ? 88 + 12 * Math.min(1, (Date.now() - doneAt) / 350) : 88 * e;
      var v = Math.round(value);
      bar.style.width = v + '%';
      cnt.textContent = ('00' + v).slice(-3);
      if (v >= 100) { fly(); return; }
      raf = win.setTimeout(tick, 16);
    }
    function fly() {
      if (done) return; done = true;
      // Punto de la "a" del logo (viewBox -9 -1483 3862 1513): centro aprox. 39.5% / 68%
      var r = logo.getBoundingClientRect();
      var ox = r.left + r.width * 0.395, oy = r.top + r.height * 0.68;
      el.style.transformOrigin = ox + 'px ' + oy + 'px';
      $('.v-open__bar', el).style.opacity = '0'; $('.v-open__meta', el).style.opacity = '0';
      if (hasGsap) {
        var tl = win.gsap.timeline({ onComplete: finish });
        tl.to(el, { scale: 34, duration: 1.45, ease: 'power3.in' }, 0)
          .to(el, { opacity: 0, duration: 0.5, ease: 'power1.in' }, 0.95);
        if (vit) tl.to(vit, { opacity: 1, duration: 0.7, ease: 'power1.out' }, 0.6).to(vit, { scale: 1, duration: 1.8, ease: 'expo.out' }, 0.5);
      } else {
        el.style.transition = 'transform 1.45s cubic-bezier(.7,0,.84,0), opacity .5s ease .95s';
        el.style.transform = 'scale(34)'; el.style.opacity = '0';
        if (vit) { vit.style.transition = 'opacity .7s ease .6s, transform 1.8s cubic-bezier(.16,1,.3,1) .5s'; vit.style.opacity = '1'; vit.style.transform = 'none'; }
        setTimeout(finish, 1500);
      }
    }
    function finish() {
      if (raf) win.clearTimeout(raf);
      if (vit) { vit.style.opacity = ''; vit.style.transform = ''; vit.style.transition = ''; vit.style.transformOrigin = ''; }
      if (el.parentNode) el.parentNode.removeChild(el);
      html.classList.remove('v3-opening');
      try { win.localStorage.setItem('vael_opened', String(Date.now())); } catch (e) {}
      doc.dispatchEvent(new CustomEvent('v3:opened'));
    }
    on(skip, 'click', function () { loaded = true; start = Date.now() - 5000; doneAt = Date.now() - 1000; });
    raf = win.setTimeout(tick, 16);
  }

  /* ---------- Encabezado + menú ---------- */
  function header() {
    var h = $('.v-header');
    if (!h) return;
    var last = 0, light = h.hasAttribute('data-light-at');
    function onScroll() {
      var y = win.scrollY || doc.documentElement.scrollTop;
      h.classList.toggle('is-scrolled', y > 40);
      if (!mobile) h.classList.toggle('is-hidden', y > last && y > 300);
      last = y;
      if (light) {
        var bone = $$('.v-bone, .v-compat').some(function (s) { var r = s.getBoundingClientRect(); return r.top <= 50 && r.bottom >= 50; });
        h.classList.toggle('is-light', bone);
      }
    }
    on(win, 'scroll', onScroll, { passive: true }); onScroll();
    $$('[data-v3-cart-open]').forEach(function (a) { on(a, 'click', openDrawer); });
    watchBubble();

    var menu = $('.v-menu');
    if (!menu) return;
    var openers = $$('[data-v3-menu-open]'), closers = $$('[data-v3-menu-close]', menu), lastFocus;
    function open() {
      lastFocus = doc.activeElement; menu.classList.add('is-open'); doc.body.classList.add('overflow-hidden');
      if (lenis) lenis.stop();
      var links = $$('.v-menu__list li', menu), sub = $('.v-menu__sub', menu), prev = $('.v-menu__preview', menu);
      if (hasGsap && !reduce) {
        win.gsap.fromTo(links.map(function (l) { return l.firstElementChild; }), { y: '110%' }, { y: '0%', duration: 1, ease: 'expo.out', stagger: 0.06, delay: 0.05 });
        win.gsap.fromTo([sub, prev], { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.8, ease: 'expo.out', delay: 0.35 });
      }
      var first = $('.v-menu__close', menu); if (first) first.focus();
    }
    function close() {
      menu.classList.remove('is-open'); doc.body.classList.remove('overflow-hidden');
      if (lenis) lenis.start();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openers.forEach(function (b) { on(b, 'click', open); });
    closers.forEach(function (b) { on(b, 'click', close); });
    on(doc, 'keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
    var imgs = $$('.v-menu__preview img', menu);
    $$('.v-menu__list a[data-preview]', menu).forEach(function (a) {
      function show() { menu.classList.add('is-hovering'); imgs.forEach(function (i) { i.classList.toggle('is-on', i.getAttribute('data-key') === a.getAttribute('data-preview')); }); }
      on(a, 'mouseenter', show); on(a, 'focus', show);
      on(a, 'mouseleave', function () { menu.classList.remove('is-hovering'); });
    });
    if (imgs[0]) imgs[0].classList.add('is-on');
  }

  /* ---------- Botones magnéticos (sutiles, sin cursor propio) ---------- */
  function magnetic() {
    if (reduce || mobile || !hasGsap) return;
    $$('.v-mag').forEach(function (b) {
      on(b, 'mousemove', function (e) {
        var r = b.getBoundingClientRect();
        win.gsap.to(b, { x: (e.clientX - r.left - r.width / 2) * 0.18, y: (e.clientY - r.top - r.height / 2) * 0.18, duration: 0.5, ease: 'power3.out' });
      });
      on(b, 'mouseleave', function () { win.gsap.to(b, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1, .5)' }); });
    });
  }

  /* ---------- Cortinas en titulares ---------- */
  function reveal() {
    var items = $$('[data-v-reveal]');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in win)) { items.forEach(function (i) { i.classList.add('v-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('v-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });
    items.forEach(function (i) { io.observe(i); });
    // Respaldo: si el observador no dispara (pestaña en segundo plano, navegadores raros), revelar por posición al hacer scroll
    function check() { items.forEach(function (i) { if (!i.classList.contains('v-in') && i.getBoundingClientRect().top < win.innerHeight * 0.92) i.classList.add('v-in'); }); }
    on(win, 'scroll', check, { passive: true }); setTimeout(check, 1200);
  }

  /* ---------- Marquesina ---------- */
  function marquee() {
    var band = $('.v-band');
    if (!band || reduce || mobile) return;
    var track = $('.v-band__track', band);
    var w = track.scrollWidth;
    if (w < band.clientWidth * 2) { track.innerHTML += track.innerHTML; w = track.scrollWidth; }
    var half = w / 2, x = 0, speed = 0.6, last = 0;
    function step(t) { var dt = Math.min(40, t - last) / 16.7; last = t; x -= speed * dt; if (-x >= half) x += half; track.style.transform = 'translate3d(' + x + 'px,0,0)'; win.requestAnimationFrame(step); }
    win.requestAnimationFrame(step);
    on(band, 'mouseenter', function () { speed = 0.15; }); on(band, 'mouseleave', function () { speed = 0.6; });
  }

  /* ---------- Anotaciones (líneas que señalan las partes) ---------- */
  function callouts(scope) {
    $$('.v-ann', scope).forEach(function (ann) {
      var svg = $('svg', ann); if (!svg) return;
      svg.innerHTML = '';
      $$('.v-ann__dot', ann).forEach(function (dot) {
        var lab = $('.v-ann__label[data-i="' + dot.getAttribute('data-i') + '"]', ann);
        if (!lab) return;
        var ax = parseFloat(dot.style.left), ay = parseFloat(dot.style.top);
        var lx = parseFloat(lab.style.left), ly = parseFloat(lab.style.top);
        var left = lab.classList.contains('is-left');
        var ey = ly + 19;
        // Codo horizontal de 44 px que termina a 8 px del texto, como en el lienzo
        var elbow = left ? lx + 240 + 52 : lx - 52, end = left ? lx + 240 + 8 : lx - 8;
        var p = doc.createElementNS('http://www.w3.org/2000/svg', 'polyline');
        p.setAttribute('points', ax + ',' + ay + ' ' + elbow + ',' + ey + ' ' + end + ',' + ey);
        p.setAttribute('pathLength', '1'); p.setAttribute('data-i', dot.getAttribute('data-i'));
        svg.appendChild(p);
      });
    });
  }

  /* ---------- Escala del escenario 1440×900 ---------- */
  function stage(sec, stg) {
    function fit() {
      var s = Math.min(sec.clientWidth / 1440, sec.clientHeight / 900, 1.3);
      stg.style.setProperty('--v-stage', s.toFixed(4));
    }
    fit(); on(win, 'resize', fit);
    return fit;
  }

  /* ---------- Vitrina ---------- */
  function vitrina() {
    var sec = $('.v-vit');
    var m = $('.v-vit-m');
    if (m) {
      var rail = $('.v-vit-m__rail', m), dots = $$('.v-vit-m__dots i', m);
      on(rail, 'scroll', function () {
        var i = Math.round(rail.scrollLeft / rail.clientWidth);
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }, { passive: true });
    }
    if (!sec || mobile) return;
    var stg = $('.v-vit__stage', sec), slides = $$('.v-vit__slide', sec), nav = $$('.v-vit__nav button', sec);
    stage(sec, stg); callouts(sec);
    var cur = 0, n = slides.length, locked = false;
    function go(i, silent) {
      i = Math.max(0, Math.min(n - 1, i));
      if (i === cur && !silent) return;
      cur = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      nav.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); b.classList.toggle('is-done', k < i); });
    }
    go(0, true);
    nav.forEach(function (b, k) { on(b, 'click', function () { if (st) { var y = st.start + (st.end - st.start) * (k / n) + 2; (lenis ? lenis.scrollTo(y, { duration: 1.1 }) : win.scrollTo(0, y)); } else go(k); }); });
    var st = null;
    if (hasST && !reduce) {
      st = win.ScrollTrigger.create({
        trigger: sec, start: 'top top', end: '+=' + (n * 70) + '%', pin: true, anticipatePin: 1,
        snap: { snapTo: function (v) { return Math.round(v * n) / n; }, duration: { min: 0.2, max: 0.6 }, ease: 'power2.inOut', delay: 0.05 },
        onUpdate: function (self) { var i = Math.min(n - 1, Math.floor(self.progress * n + 0.0001)); if (i !== cur) go(i); }
      });
      sec.setAttribute('data-pinned', 'true');
    } else {
      // Sin ScrollTrigger: rueda cambia de pieza; teclado ← →
      var acc = 0, lastT = 0;
      on(sec, 'wheel', function (e) {
        if (reduce) return;
        var now = Date.now(); if (now - lastT < 750) { e.preventDefault(); return; }
        acc += e.deltaY;
        if (Math.abs(acc) > 120) {
          var nx = cur + (acc > 0 ? 1 : -1); acc = 0;
          if (nx >= 0 && nx < n) { e.preventDefault(); lastT = now; go(nx); }
        }
      }, { passive: false });
    }
    on(sec, 'keydown', function (e) { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
  }

  /* ---------- Video (banner de cine) ---------- */
  function video() {
    var modal = $('.v-modal'); if (!modal) return;
    var v = $('video', modal);
    $$('[data-v3-video]').forEach(function (b) { on(b, 'click', function () { modal.classList.add('is-open'); if (lenis) lenis.stop(); v.currentTime = 0; v.play().catch(function () {}); $('.v-modal__close', modal).focus(); }); });
    function close() { modal.classList.remove('is-open'); v.pause(); if (lenis) lenis.start(); }
    on($('.v-modal__close', modal), 'click', close);
    on(modal, 'click', function (e) { if (e.target === modal) close(); });
    on(doc, 'keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  }

  /* ---------- Arma tu kit ---------- */
  function kit() {
    var k = $('.v-kit'); if (!k) return;
    var items = $$('.v-kit__item', k), btn = $('[data-v3-kit-add]', k);
    var elCount = $('[data-v3-kit-count]', k), elSub = $('[data-v3-kit-sub]', k), elDisc = $('[data-v3-kit-disc]', k), elTotal = $('[data-v3-kit-total]', k);
    var pct = parseFloat(k.getAttribute('data-discount') || '10') / 100, min = parseInt(k.getAttribute('data-min') || '2', 10);
    function price(it) { var sel = $('select', it); return parseInt(sel ? sel.selectedOptions[0].getAttribute('data-price') : it.getAttribute('data-price'), 10); }
    function variant(it) { var sel = $('select', it); return sel ? sel.value : it.getAttribute('data-variant'); }
    function calc() {
      var sub = 0, n = 0;
      items.forEach(function (it) { if (it.getAttribute('aria-pressed') === 'true') { sub += price(it); n++; } });
      var disc = n >= min ? Math.round(sub * pct) : 0;
      elCount.textContent = n;
      elSub.textContent = money(sub);
      elDisc.textContent = disc ? '−' + money(disc) : (n ? (strings.kitHint || 'Elige 2 para el 10%') : money(0));
      elTotal.textContent = money(sub - disc);
      btn.disabled = n === 0;
    }
    items.forEach(function (it) {
      function toggle() { it.setAttribute('aria-pressed', it.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); calc(); }
      on(it, 'click', function (e) { if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return; toggle(); });
      on(it, 'keydown', function (e) { if (e.target !== it) return; if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
      var sel = $('select', it); on(sel, 'change', calc); on(sel, 'click', function (e) { e.stopPropagation(); });
    });
    calc();
    $$('[data-v3-kit-preset]').forEach(function (b) {
      on(b, 'click', function (e) {
        e.preventDefault();
        var want = (b.getAttribute('data-v3-kit-preset') || '').split(',').filter(Boolean);
        items.forEach(function (it) { it.setAttribute('aria-pressed', want.indexOf(it.getAttribute('data-handle')) >= 0 ? 'true' : 'false'); });
        calc();
        var top = k.getBoundingClientRect().top + win.pageYOffset - 24;
        if (lenis) lenis.scrollTo(top); else win.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    on(btn, 'click', function () {
      var list = items.filter(function (it) { return it.getAttribute('aria-pressed') === 'true'; }).map(function (it) { return { id: parseInt(variant(it), 10), quantity: 1 }; });
      if (!list.length) return;
      var label = btn.textContent; btn.disabled = true; btn.textContent = strings.adding || 'Agregando…';
      cartAdd(list).then(function () { btn.textContent = strings.added || 'Agregado ✓'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800); })
        .catch(function () { btn.textContent = strings.error || 'No se pudo agregar'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200); });
    });
  }

  /* ---------- Agregar rápido en tarjetas ---------- */
  function quickAdd(scope) {
    $$('[data-v3-quick]', scope).forEach(function (b) {
      on(b, 'click', function (e) {
        e.preventDefault();
        var id = parseInt(b.getAttribute('data-v3-quick'), 10); if (!id) return;
        var span = $('span', b), label = span ? span.textContent : '';
        b.classList.add('is-added'); if (span) span.textContent = strings.added || 'Agregado ✓';
        cartAdd([{ id: id, quantity: 1 }]).catch(function () { if (span) span.textContent = strings.error || 'No se pudo agregar'; })
          .then(function () { setTimeout(function () { b.classList.remove('is-added'); if (span) span.textContent = label; }, 1800); });
      });
    });
  }

  /* ---------- Colección: filtros ---------- */
  function collection() {
    var root = $('[data-v3-collection]'); if (!root) return;
    var tabs = $$('.v-tab', root), devs = $$('.v-dev', root), cards = $$('.v-grid > [data-funcion]', root), count = $('.v-count', root), empty = $('.v-empty', root);
    var sort = $('.v-sort', root), reset = $('[data-v3-reset]', root);
    var toggle = $('[data-v3-filter-toggle]', root), panel = $('#v3-filters', root);
    function openPanel(open) {
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { panel.hidden = false; if (hasGsap && !reduce) { win.gsap.fromTo(panel, { height: 0, opacity: 0 }, { height: 'auto', opacity: 1, duration: 0.45, ease: 'power3.out', clearProps: 'height' }); } }
      else if (hasGsap && !reduce) { win.gsap.to(panel, { height: 0, opacity: 0, duration: 0.3, ease: 'power2.in', onComplete: function () { panel.hidden = true; win.gsap.set(panel, { clearProps: 'height,opacity' }); } }); }
      else panel.hidden = true;
      if (hasST) setTimeout(function () { win.ScrollTrigger.refresh(); }, 500);
    }
    on(toggle, 'click', function () { openPanel(toggle.getAttribute('aria-expanded') !== 'true'); });
    on(doc, 'keydown', function (e) { if (e.key === 'Escape' && toggle && toggle.getAttribute('aria-expanded') === 'true') { openPanel(false); toggle.focus(); } });
    var all = root.getAttribute('data-all') === 'true';
    var fn = root.getAttribute('data-current') || 'todo', dev = null;
    var copy = {};
    try { copy = JSON.parse($('#v3-collection-copy').textContent); } catch (e) {}
    function apply(push) {
      var real = 0, soon = 0;
      cards.forEach(function (c) {
        var okF = fn === 'todo' || c.getAttribute('data-funcion') === fn;
        var okD = !dev || (c.getAttribute('data-con') || '').split(' ').indexOf(dev) >= 0;
        var show = okF && okD;
        c.classList.toggle('is-hidden', !show);
        if (show) { if (c.hasAttribute('data-soon')) soon++; else real++; }
      });
      if (count) count.textContent = real + ' ' + (real === 1 ? (strings.piece || 'pieza') : (strings.pieces || 'piezas')) + (soon ? ' · ' + soon + ' ' + (strings.soon || 'muy pronto') : '');
      if (empty) empty.classList.toggle('is-on', real + soon === 0);
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-fn') === fn ? 'true' : 'false'); });
      devs.forEach(function (d) { d.setAttribute('aria-pressed', d.getAttribute('data-dev') === dev ? 'true' : 'false'); });
      var c = copy[fn]; if (c) { var t1 = $('[data-v3-t1]', root), t2 = $('[data-v3-t2]', root), cr = $('[data-v3-crumb]', root); if (t1) t1.textContent = c.t1; if (t2) t2.textContent = c.t2; if (cr) cr.textContent = fn === 'todo' ? (strings.all || 'Todo') : c.name; }
      if (push && all) { var u = new URL(win.location.href); if (fn === 'todo') u.searchParams.delete('f'); else u.searchParams.set('f', fn); win.history.replaceState(null, '', u); }
      if (hasST) win.ScrollTrigger.refresh();
    }
    if (all) {
      var u0 = new URL(win.location.href); if (u0.searchParams.get('f')) fn = u0.searchParams.get('f');
      tabs.forEach(function (t) { on(t, 'click', function (e) { e.preventDefault(); fn = t.getAttribute('data-fn'); apply(true); openPanel(false); }); });
    }
    devs.forEach(function (d) { on(d, 'click', function () { dev = dev === d.getAttribute('data-dev') ? null : d.getAttribute('data-dev'); apply(false); }); });
    on(reset, 'click', function () { fn = all ? 'todo' : fn; dev = null; apply(true); });
    on(sort, 'change', function () { var u = new URL(win.location.href); u.searchParams.set('sort_by', sort.value); win.location.href = u.toString(); });
    apply(false);
    quickAdd(root);
  }

  /* ---------- Producto (4.0: un solo formulario, personalización y validación) ---------- */
  function product() {
    var root = $('[data-v3-product]'); if (!root) return;
    var data = {};
    try { data = JSON.parse($('#v3-product-json').textContent); } catch (e) { return; }
    var form = $('form[data-v3-buy]', root);
    var variants = data.variants || [];
    var current = variants.filter(function (v) { return v.id === data.selected; })[0] || variants[0];
    if (form) form.noValidate = true;

    // Galería: miniaturas en escritorio, carrusel en móvil
    var gal = $('.v-gal', root), bigs = gal ? $$('.v-gal__big img', gal) : [], thumbs = gal ? $$('.v-gal__thumbs button', gal) : [];
    function showPhoto(i) { bigs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); }); thumbs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); }); }
    thumbs.forEach(function (t, i) { on(t, 'click', function () { showPhoto(i); }); });
    var mrail = $('.v-pdp__m-gal .v-rail', root), mdots = $$('.v-pdp__m-dots i', root);
    on(mrail, 'scroll', function () { var i = Math.round(mrail.scrollLeft / mrail.clientWidth); mdots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }, { passive: true });

    // Opciones: botones (color, material) o select (silueta)
    function chosen() {
      var out = [];
      $$('[data-opt]', root).forEach(function (el) {
        var pos = parseInt(el.getAttribute('data-opt'), 10) - 1;
        if (el.tagName === 'SELECT') out[pos] = el.value; else if (el.checked) out[pos] = el.value;
      });
      return out;
    }
    function labelFor(pos) {
      var el = $('select[data-opt="' + pos + '"]', root);
      if (el) { var o = el.options[el.selectedIndex]; return o ? (o.getAttribute('data-label') || o.value) : ''; }
      el = $('input[data-opt="' + pos + '"]:checked', root);
      return el ? (el.getAttribute('data-label') || el.value) : '';
    }
    function setButtons(ok, text) {
      $$('[data-v3-add], [data-v3-buynow], [data-v4-sticky]', root).forEach(function (b) { b.disabled = !ok; });
      var add = $('[data-v3-add]', root); if (add) add.textContent = text;
    }
    function selectVariant(v, moveGallery) {
      if (!v) return;
      current = v;
      $$('[data-v3-price]', root).forEach(function (el) { el.textContent = money(v.price); });
      $$('[data-v3-variant-id]', root).forEach(function (el) { el.value = v.id; });
      $$('[data-v3-opt-label]', root).forEach(function (el) { el.textContent = labelFor(el.getAttribute('data-v3-opt-label')); });
      setButtons(v.available, v.available ? (strings.addToCart || 'Agregar al carrito') : (strings.soldOut || 'Agotado'));
      if (moveGallery && v.media_index !== null && v.media_index !== undefined) {
        if (thumbs.length) showPhoto(v.media_index);
        if (mrail && mrail.clientWidth) mrail.scrollTo({ left: mrail.clientWidth * v.media_index, behavior: reduce ? 'auto' : 'smooth' });
      }
      var u = new URL(win.location.href); u.searchParams.set('variant', v.id); win.history.replaceState(null, '', u);
    }
    $$('[data-opt]', root).forEach(function (el) {
      on(el, 'change', function () {
        var want = chosen().join('|');
        var v = variants.filter(function (x) { return x.options.join('|') === want; })[0];
        if (v) selectVariant(v, true);
        else { current = null; setButtons(false, strings.unavailable || 'No disponible'); }
      });
    });
    $$('.v-qty', root).forEach(function (q) {
      var i = $('input', q);
      on($('[data-dec]', q), 'click', function () { i.value = Math.max(1, (parseInt(i.value, 10) || 1) - 1); });
      on($('[data-inc]', q), 'click', function () { i.value = Math.min(9, (parseInt(i.value, 10) || 1) + 1); });
    });

    // Plan B: foto y nombre
    var MAX = 15 * 1024 * 1024;
    var formErr = $('[data-v4-form-err]', root);
    function fieldOf(el) { return el.closest('[data-v4-field]'); }
    function setErr(el, msg) {
      var f = fieldOf(el), err = f && $('.v4-field__err', f);
      if (f) f.classList.toggle('is-err', !!msg);
      el.setAttribute('aria-invalid', msg ? 'true' : 'false');
      if (err) { err.textContent = msg || ''; err.hidden = !msg; }
    }
    $$('[data-v4-photo]', root).forEach(function (inp) {
      var wrap = fieldOf(inp), prev = wrap && $('[data-v4-preview]', wrap), name = wrap && $('[data-v4-file]', wrap), img = prev && $('img', prev);
      if (img) on(img, 'error', function () { prev.hidden = true; });
      on(inp, 'change', function () {
        var f = inp.files && inp.files[0];
        function reset(msg) { inp.value = ''; setErr(inp, msg || ''); if (prev) prev.hidden = true; if (name) name.textContent = strings.pickPhoto || 'Elegir una foto'; if (wrap) wrap.classList.remove('has-file'); }
        if (!f) return reset();
        if (f.size > MAX) return reset(strings.photoBig);
        if (f.type && f.type.indexOf('image/') !== 0) return reset(strings.photoType);
        setErr(inp, '');
        if (name) name.textContent = f.name;
        if (wrap) wrap.classList.add('has-file');
        if (img && win.URL && win.URL.createObjectURL) {
          if (img.getAttribute('data-url')) win.URL.revokeObjectURL(img.getAttribute('data-url'));
          var url = win.URL.createObjectURL(f); img.setAttribute('data-url', url); img.src = url; prev.hidden = false;
        }
      });
    });
    $$('[data-v4-name]', root).forEach(function (inp) {
      var cnt = $('[data-v4-count]', fieldOf(inp));
      function upd() { if (cnt) cnt.textContent = inp.value.length + '/12'; if (inp.value.trim()) setErr(inp, ''); }
      on(inp, 'input', upd); upd();
    });
    function validate() {
      var bad = null;
      $$('[data-v4-photo]', root).forEach(function (inp) {
        if (inp.getAttribute('data-required') === 'true' && !(inp.files && inp.files.length)) { setErr(inp, strings.needPhoto || 'Sube la foto para tu pieza.'); bad = bad || inp; }
      });
      $$('[data-v4-name]', root).forEach(function (inp) {
        var val = inp.value.replace(/\s+/g, ' ').trim();
        inp.value = val;
        if ((inp.getAttribute('data-required') === 'true' && !val) || val.length > 12) { setErr(inp, strings.needName || 'Escribe el nombre, hasta 12 caracteres.'); bad = bad || inp; }
      });
      if (!bad) return true;
      var box = fieldOf(bad) || bad;
      var top = box.getBoundingClientRect().top + win.pageYOffset - 120;
      if (lenis) lenis.scrollTo(top); else win.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      try { bad.focus({ preventScroll: true }); } catch (e) { bad.focus(); }
      return false;
    }

    // Agregar al carrito: manda el formulario completo (multipart) para que viajen la foto,
    // el nombre y lo que agregue el bloque de app de personalización.
    function add(btn, then) {
      if (!form || !current || !btn) return;
      if (formErr) formErr.hidden = true;
      if (!validate()) return;
      var label = btn.textContent; btn.disabled = true; btn.textContent = strings.adding || 'Agregando…';
      $$('[data-v3-variant-id]', form).forEach(function (el) { el.value = current.id; });
      var fd = new FormData(form);
      fd.set('id', current.id);
      var ph = $('[data-v4-photo]', form);
      if (ph && !(ph.files && ph.files.length)) fd.delete('properties[Foto]');
      if (fd.get('properties[Nombre]') === '') fd.delete('properties[Nombre]');
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', win.location.pathname);
      fetch((win.routes && win.routes.cart_add_url) || '/cart/add', {
        method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status && res.status >= 400) throw new Error(res.description || res.message || '');
        var drawer = $('cart-drawer');
        if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        if (drawer && drawer.renderContents && res.sections) { try { drawer.renderContents(res); } catch (e) { /* no-op */ } }
        syncCount();
        btn.classList.add('is-added'); btn.textContent = strings.added || 'Agregado ✓';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; btn.disabled = false; }, 1800);
        if (then) then();
      }).catch(function (err) {
        btn.textContent = strings.error || 'No se pudo agregar';
        if (formErr) { formErr.textContent = (strings.error || 'No se pudo agregar') + (err && err.message ? ': ' + err.message : '.'); formErr.hidden = false; }
        setTimeout(function () { btn.textContent = label; btn.disabled = !(current && current.available); }, 2200);
      });
    }
    on(form, 'submit', function (e) { e.preventDefault(); add($('[data-v3-add]', form)); });
    $$('[data-v3-buynow]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); add(b, function () { win.location.href = '/checkout'; }); }); });
    $$('[data-v4-sticky]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); add(b); }); });

    // Barra fija: aparece cuando el botón de compra sale de la pantalla
    var sticky = $('.v-sticky', root), anchor = $('[data-v3-sticky-after]', root);
    if (sticky && anchor && 'IntersectionObserver' in win) {
      new IntersectionObserver(function (en) {
        var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      }, { threshold: 0 }).observe(anchor);
    }
    quickAdd(root);
    selectVariant(current, false);
  }

  /* ---------- Arranque ---------- */
  function init() {
    doc.body.classList.add('v3');
    initLenis();
    opening();
    header();
    reveal();
    marquee();
    vitrina();
    video();
    kit();
    collection();
    product();
    magnetic();
    syncCount();
    if (hasST) setTimeout(function () { win.ScrollTrigger.refresh(); }, 600);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', function (e) { reveal(); callouts(e.target); quickAdd(e.target); });
})();
